import React, { useState } from "react";
import Red from "../../assets/assets/red-pdf.svg";
import Empty from "../../assets/assets/empty-card.svg";
import { useHistory } from "react-router-dom";
import Close from "../../assets/assets/close.svg";
import Forward from "../../assets/assets/forward.svg";
import Loader from "../../components/Loader/Loader";
import chip from "../../assets/assets/chips.png";
import nfc from "../../assets/assets/nfc.svg";
import Spinner from "react-spinner-material";
import { PropTypes } from "prop-types";

export const Cards = ({
  singleDoc,
  results,
  isGettingCards,
  isApplying,
  testCardStatus,
  status,
  showFrame,
  resultsLength,
}) => {
  const history = useHistory();

  const [state, setState] = useState({
    showModal: false,
    showTestModal: false,
  });

  const initializeRequest2 = () => {
    history.push({
      pathname: "/payment-testcard",
    });
  };

  const openTestModal = () => {
    setState({
      ...state,
      showTestModal: true,
    });
  };

  const hideTestModal = () => {
    setState({
      ...state,
      showTestModal: false,
    });
  };

  const res = (str) => {
    let newStr = str.split("_").join(" ");
    return newStr;
  };

  const seperateNo = (str) => {
    let newNo = str
      .replace(/[^\dA-Z]/g, "")
      .replace(/(.{4})/g, "$1 ")
      .trim();
    return newNo;
  };

  const newresults =
    results &&
    results[0] &&
    results[0].card_request &&
    results[0].card_request[0] &&
    results[0].card_request[0].card_details &&
    results[0].card_request[0].card_details.slice(0, 2);

  return (
    <div>
      <div className="doc-test-area">
        <div>
          <div className="dashboard-main-header">
            <div className="dashboard-main-header-title2">
              <span>API Documentation</span>
            </div>
          </div>

          <div className="overlay-holder">
            <div className="single-pos-doc">
              <div className="single-pos-doc-each">
                <div className="single-pos-doc-each-image">
                  <img src={Red} alt="pdf" />
                </div>
              </div>

              <div className="single-pos-doc-each-name">
                <span>{singleDoc.name}</span>
              </div>
            </div>
            <div className="overlay">
              <button
                data-testid="btn-showframe"
                onClick={() =>
                  showFrame(singleDoc.id, singleDoc.link, singleDoc.name)
                }
              >
                view
              </button>
            </div>
          </div>
        </div>

        {isGettingCards ? (
          <div className="pos-doc-sec-bottom">
            <div className="center-spinner">
              <Spinner
                size={120}
                color={"#047558"}
                spinnerwidth={5}
                visible={true}
              />
            </div>
          </div>
        ) : (
            <div className="pos-doc-sec-bottom">
              <div className="pos-doc-sec-bottom-title">
                <h3>Test Cards</h3>
                {results && results.length > 0 && (
                  <span
                    data-testid="btn-showTest"
                    onClick={() => openTestModal()}
                  >
                    See all &nbsp; <img src={Forward} alt="icon" />
                  </span>
                )}
              </div>

              {state.showTestModal && (
                <div className="test-results">
                  <div className="test-results-title">
                    <span>My Test Cards</span>
                    <div
                      data-testid="btn-showModal"
                      className="image"
                      onClick={() => hideTestModal()}
                    >
                      <img src={Close} alt="close" />
                    </div>
                  </div>
                  <div className="test-results-content">
                    {results &&
                      results.map(
                        (result, index) =>
                          result.card_request &&
                          result.card_request.map(
                            (item, index) =>
                              item.card_details &&
                              item.card_details.map((card, index) => (
                                <div
                                  className="test-results-content-item"
                                  key={card.card_details_id}
                                >
                                  <div className="above">
                                    <div className="header">
                                      <h1>Test Card {index + 1}</h1>
                                      <p>{res(card.card_type)} card</p>
                                    </div>

                                    <div className="mid">
                                      <div className="mid-mid">
                                        <div className="chip">
                                          <img src={chip} alt="chip" />
                                        </div>
                                        <div>
                                          <div className="mid-sec">
                                            <h2>EXPIRY:</h2>{" "}
                                            <span>{card.expiry_date}</span>
                                          </div>
                                          <div className="mid-sec">
                                            <h2>PIN:</h2> <span>{card.cvv}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <h3>{seperateNo(card.pan)}</h3>
                                  </div>
                                  <div className="below">
                                    <div className="chip2">
                                      <img src={nfc} alt="chip" />
                                    </div>
                                  </div>
                                </div>
                              ))
                          )
                      )}
                  </div>
                </div>
              )}

              <>
                {results && results.length === 0 && (
                  <>
                    <div className="empty-card">
                      <div className="empty-card-section">
                        <div className="empty-card-section-image">
                          <div className="empty-card-section-image-div">
                            <img src={Empty} alt="empty-card" />
                          </div>
                          <p>No test cards</p>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
              {resultsLength && Object.keys(resultsLength).length !== 0 && (
                <div className="card-spec">
                  <div className="test-results-full">
                    {newresults &&
                      newresults.map((card, index) => (
                        <div
                          className="test-results-full-item"
                          key={card.card_details_id}
                        >
                          <div className="above">
                            <div className="header">
                              <h1>Test Card {index + 1}</h1>
                              <p>{res(card.card_type)} card</p>
                            </div>

                            <div className="mid">
                              <div className="mid-mid">
                                <div className="chip">
                                  <img src={chip} alt="chip" />
                                </div>
                                <div>
                                  <div className="mid-sec">
                                    <h2>EXPIRY:</h2>{" "}
                                    <span>{card.expiry_date}</span>
                                  </div>
                                  <div className="mid-sec">
                                    <h2>PIN:</h2> <span>{card.cvv}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <h3>{seperateNo(card.pan)}</h3>
                          </div>
                          <div className="below">
                            <div className="chip2">
                              <img src={nfc} alt="chip" />
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                  {testCardStatus >= 1 && (
                    <button
                      data-testid="empty-card-button"
                      className="empty-card-button"
                      onClick={() => initializeRequest2()}
                      disabled={isApplying}
                    >
                      {isApplying ? <Loader /> : "REQUEST FOR A NEW CARD"}
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
      </div>
    </div>
  );
};

Cards.propTypes = {
  isApplying: PropTypes.bool,
  isGettingCards: PropTypes.bool,
  results: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.number, PropTypes.func]),
  resultsLength: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  showFrame: PropTypes.func,
  singleDoc: PropTypes.object,
  status: PropTypes.array,
  testCardStatus: PropTypes.number
}

export default Cards;
